export const practitionerSpecialtiesFields = [
  {
    name: 'omniPractice',
    label: 'Omni pratique'
  },
  {
    name: 'implantology',
    label: 'Implantologie'
  },
  {
    name: 'orthodontics',
    label: 'Orthodontie'
  },
  {
    name: 'periodontology',
    label: 'Parodontologie'
  },
  {
    name: 'endodontics',
    label: 'Endodontie'
  }
];
